<template>
  <v-layout>
      <!-- <v-tabs
      v-model="active"
      fixed-tabs
      slider-color="primary"
      style="width:100%;"
      v-if="!messageSent"
    >
      <v-tab
        v-for="n in ['SMS', 'Details']"
        :key="n"
        ripple
      >
        {{ n }}

      </v-tab>
      <v-tab-item
        key="SMS"
      > -->
        <v-card flat style="width:100%; height:100%">
          <v-container v-if="!messageSent" class="text-xs-center">
      <v-select
        label="Message Type" 
        :items="types"
        v-model="messageType"
        item-value="type"
        item-text="name"
      />
        <v-btn
          @click="lookupDialog = true"
          color="primary"
          style="float: right;"
        >
              Lookup ICCID
        </v-btn>
        <v-switch
          v-model="bulk"
          label="Bulk Paste"
          color="primary"
        ></v-switch>
      <v-textarea label="Bulk Paste ICCID's Here" @keydown.prevent @input="updateICCID" v-model="inputICCID" v-if="bulk"/>
      <v-combobox
        v-if="!bulk"
        v-model="ICCIDarray"
        chips
        deletable-chips
        label="Input ICCID and press enter"
        type="number"
        multiple
        outline
      ></v-combobox>
      <v-autocomplete
        label="Message Template"
        :items="messageTemplates"
        v-model="message"
        multiple
        chips
        deletable-chips
      />
      <v-text-field 
        v-for="(m, i) in message"
        v-model="message[i]"
        :key="i"
        :label="'Message To Send ' + (i+1)"
        :append-icon="$vuetify.icons.clear"
        @click:append="message.splice(i, 1)"
      />
      <v-btn @click="sendMessages" color="primary" :disabled="!message || ICCIDarray.length < 1" :loading="sending">Send Messages</v-btn>
    </v-container>  
        </v-card>
      <!-- </v-tab-item>
      <v-tab-item
        key="Details"
      >
        <v-card flat>
          <v-container v-if="!messageSent">
            <v-textarea v-model="excelInput" label="Excel Data Input"></v-textarea>
            <v-layout row wrap>
              <v-flex
                v-for="(column, i) in availableColumns"
                xs3
                :key="i"
              >
                <v-select
                  :label="'Column: ' + i"
                  v-model="columnMap[i]"
                  :items="availableColumns"
                  return-object
                  outline
                  class="mx-1"
                  height="1"
                />
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-checkbox v-model="includeHeaders" label="Input includes header row"></v-checkbox>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="processRawData" :disabled="!excelInput" :loading="processing">Process Data</v-btn>
            </v-layout>
            <div v-if="dataProcessed" class="mt-5">
              <span class="title">Output Data</span>
              <v-data-table hide-actions :items="processedData" :headers="columnMap">
                <template slot="items" slot-scope="props">
                  <tr>
                    <td v-for="column in columnMap" :key="column">{{props.item[column.value]}}</td>
                  </tr>
                </template>
              </v-data-table>
              <v-layout align-center>
                <v-spacer></v-spacer>
                <v-checkbox class="shrink" label="I confirm the above output is correct" v-model="dataLooksGood"></v-checkbox>
                <v-btn color="primary" @click="sendSimDetails" :loading="sending" :disabled="!dataLooksGood">Update Sim Details</v-btn>
              </v-layout>
            </div>
          </v-container>
          </v-card>
      </v-tab-item>
    </v-tabs> -->
      <v-container v-if="messageSent">
        <v-btn @click="reset" color="primary">Return</v-btn>
      <v-data-table
        :headers="headers"
        :items="filteredMessageStates"
        class="elevation-1"
        :expand="expandResults"
        item-key="id"
        hide-actions
      >
        <template v-slot:items="props">
          <tr @click="props.expanded = !props.expanded">
            <td>{{ props.item.ICCID }}</td>
            <td>{{ props.item.message }}</td>
            <td>
              <v-progress-circular
                v-if="props.item.state === 0"
                indeterminate
                color="primary"
              ></v-progress-circular>
              <v-icon
                :color="props.item.state === -1 ? 'error' : 'success'"
                v-else
              >
                {{ props.item.state === -1 ? 'mdi-alert-circle' : 'mdi-check-circle' }}
              </v-icon>
            </td>
          </tr>
        </template>
        <template v-slot:expand="props">
          <v-card flat>
            <v-card-text v-if="props.item.packet">Request<pre>{{ props.item.packet }}</pre></v-card-text>
            <v-card-text v-if="props.item.response">Response<pre>{{ props.item.response }}</pre></v-card-text>
          </v-card>
        </template>
      </v-data-table>
    </v-container> 
    <v-dialog v-model="lookupDialog" persistent max-width="400">
        <v-card>
          <v-card-title class="headline">Lookup ICCID from ESN or IMEI</v-card-title>
          <v-card-text>Choose the source and type you want to use as a lookup.</v-card-text>
          <v-card-text>
            <v-select :items="['ESN', 'IMEI']" v-model="lookupType" />
            <v-select :items="['Nexus', 'Calamp-CTC']" v-model="lookupSource" />
            <v-text-field type="number" v-model="lookupNumber" :label="`Enter ${lookupType}`" />
            <v-btn :disabled="!lookupNumber" :loading="lookingUp" @click="lookupICCID" block color="success">Lookup</v-btn>
            <div class="text-xs-center">OR</div>
            <v-btn block @click="lookupDialog = false">Close</v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-snackbar
        v-model="lookupNoResults"
        bottom
      >
        No Results found for that number.
        <v-btn
          color="pink"
          flat
          @click="lookupNoResults = false"
        >
          Close
        </v-btn>
      </v-snackbar>
  </v-layout>
</template>

<script>
import { fireStore } from '../firebase'
import moment from 'moment'
export default {
  data () {
    return {
      active: null,
      excelInput: '',
      dataLooksGood: false,
      includeHeaders: false,
      processedData: [],
      dataProcessed: false,
      processing: false,
      expandResults: false,
      simDetailsSent: false,
      lookupDialog: false,
      lookupType: 'ESN',
      lookupSource: 'Calamp-CTC',
      lookupNumber: '',
      lookupNoResults: false,
      lookingUp: false,
      availableColumns: [
        {text: 'simId', value: 'simId'},
        {text: 'customAttribute1', value: 'customAttribute1'},
        {text: 'customAttribute2', value: 'customAttribute2'},
        {text: 'customAttribute3', value: 'customAttribute3'},
        {text: 'customAttribute4', value: 'customAttribute4'},
        {text: 'customAttribute5', value: 'customAttribute5'},
        {text: 'state', value: 'state'},
        {text: 'customerServiceProfile', value: 'customerServiceProfile'}
      ],
      columnMap: [
        {text: 'simId', value: 'simId'},
        {text: 'customAttribute1', value: 'customAttribute1'},
        {text: 'customAttribute2', value: 'customAttribute2'},
        {text: 'customAttribute3', value: 'customAttribute3'},
        {text: 'customAttribute4', value: 'customAttribute4'},
        {text: 'customAttribute5', value: 'customAttribute5'},
        {text: 'state', value: 'state'},
        {text: 'customerServiceProfile', value: 'customerServiceProfile'}
      ],
      messageTemplates: [],
      messageType: 0,
      inputICCID: '',
      ICCIDarray: sessionStorage.getItem('ICCIDS') ? JSON.parse(sessionStorage.getItem('ICCIDS')) : [],
      bulk: false,
      message: '',
      sending: false,
      messageSent: false,
      snap: null,
      authToken: null,
      headers: [
        { text: 'ICCID', value: 'ICCID' },
        { text: 'Message', value: 'message' },
        { text: 'State', value: 'state' }
      ],
      messageStates: [],
      types: [
        { type: 0, name: 'Payload SMS' },
        { type: 1, name: 'Transactional SMS' }
      ]
    }
  },
  mounted () {
    // this.bulk = this.ICCIDarray.length < 1
    sessionStorage.removeItem('ICCIDS')
    this.getSMSTemplates()
  },
  beforeDestroy () {
    if (this.snap !== null) {
      this.snap()
    }
  },
  watch: {
    lookupDialog (val) {
      if (val) {
        this.lookingUp = true
        fetch('https://cwelite.aquariusit.com/calampMiddleManGetToken.php',
          {
            method: 'post',
            headers: {
              'Content-Type': 'application/json'
            }
          }
        )
        .then((response) => {
          return response.json()
        })
        .then((token) => {
          this.authToken = token.authToken
          this.lookingUp = false
        })
        .catch(error => alert(error))
      }
    }
  },
  computed: {
    filteredMessageStates () {
      let filteredMessageStates = []
      for (let i = 0; i < this.messageStates.length; i++) {
        let element = this.messageStates[i]
        element.message = atob(element.message)
        if (element.response === undefined) {
          element.state = 0
        } else {
          for (let value in element.response) {
            if (element.response.id) {
              element.state = -1
            } else if (element.response[value].return.returnCode.majorReturnCode === '000') {
              element.state = 1
            } else {
              element.state = -1
            }
          }
        }
        element.packet = element.packet === undefined ? '' : JSON.stringify(element.packet, null, ' ')
        element.response = element.response === undefined ? '' : JSON.stringify(element.response, null, ' ')
        filteredMessageStates.push(element)
      }
      return filteredMessageStates
    }
  },
  methods: {
    getSMSTemplates () {
      this.messageTemplates = []
      fireStore.collection('smsTemplates').where('engineer', '==', true).orderBy('text').get().then((snap) => {
        snap.forEach((doc) => {
          this.messageTemplates.push(doc.data())
        })
      })
    },
    lookupICCID () {
      this.lookingUp = true
      if (this.lookupSource === 'Nexus') {
        let lookupType = this.lookupType === 'ESN' ? 'uid' : 'IMEI'
        fireStore.collection('Devices').where(lookupType, '==', this.lookupNumber).get().then((snap) => {
          if (snap.docs.length) {
            snap.forEach((doc) => {
              this.ICCIDarray.push(doc.data().SIM)
            })
            this.lookupDialog = false
          } else {
            this.lookupNoResults = true
          }
          this.lookingUp = false
        })
      } else {
        var requestOptions = {
          method: 'POST',
          redirect: 'follow',
          mode: 'cors',
          body: JSON.stringify({
            'params': `{"search": { "queryString": "${this.lookupNumber}"}}`,
            'endpoint': `device-services/devices/smartsearch?include=groups&withIdReport=true&withCredentials=true&withLocation=true&expand=deviceConfiguration&v=2.1&pg=1&pgsize=10&sort=+name`,
            'authToken': this.authToken
          }),
          headers: {
            'Content-Type': 'application/json'
          }
        }

        fetch('https://cwelite.aquariusit.com/calampMiddleManPost.php', requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.response.results.length) {
              this.ICCIDarray.push(result.response.results[0].device.iccid)
              this.lookupDialog = false
            } else {
              this.lookupNoResults = true
            }
            this.lookingUp = false
          })
      }
    },
    reset () {
      this.snap()
      this.sending = false
      this.messageSent = false
    },
    processRawData () {
      this.processing = true
      this.processedData = []
      const columnMap = this.columnMap
      let rows = []
      rows = this.excelInput.split('\n')
      if (this.includeHeaders) {
        rows.splice(0, 1)
      }
      rows.forEach(row => {
        if (row === '') {
          return
        }
        const cols = row.split('\t')
        const obj = {}
        for (let i = 0; i < cols.length; i++) {
          if (i === 0) {
            columnMap.splice(cols.length)
          }
          if (cols[i] && cols[i].length > 0 && columnMap[i]) {
            obj[columnMap[i].value] = cols[i]
          }
        }
        this.processedData.push(obj)
      })
      this.dataProcessed = true
      this.processing = false
    },
    updateICCID () {
      let concatICCIDs = this.inputICCID.replace(/\s/g, '').replace(/;/g, '').replace(/,/g, '')
      this.ICCIDarray = this.ICCIDarray.concat(concatICCIDs.match(/(.{1,20})/g)).filter((v, i, a) => a.indexOf(v) === i && !isNaN(v))
      this.inputICCID = ''
      this.bulk = false
    },
    startSnapshot (id) {
      this.snap = fireStore.collection('SIMmessages').doc(id).onSnapshot(snap => {
        let data = snap.data().messages
        for (let message of data) {
          message.id = message.ICCID + message.message
        }
        this.messageStates = data
      })
    },
    sendMessages () {
      this.sending = true
      let messageData = []
      for (let i = 0; i < this.ICCIDarray.length; i++) {
        if (this.ICCIDarray[i].length !== 20) {
          alert(`Cannot send messages! Invalid ID: ${this.ICCIDarray[i]}`)
          this.sending = false
          return
        }
        for (let m in this.message) {
          messageData.push({
            messageType: this.messageType,
            ICCID: this.ICCIDarray[i],
            message: btoa(this.message[m])
          })
        }
      }
      fireStore.collection('SIMmessages').add({
        messages: messageData,
        time: moment().format('YYYY-MM-DD HH:mm'),
        user: this.$store.getters.user.name
      }).then((val) => {
        this.startSnapshot(val.id)
        this.messageSent = true
      }).catch((error) => {
        alert('Unexpected Error Occured')
        console.log(error)
      })
    },
    sendSimDetails () {
      this.sending = true
      let messageData = []
      for (let i = 0; i < this.processedData.length; i++) {
        let msgObj = {}
        msgObj.packet = this.processedData[i]
        msgObj.packet.simIdType = 'ICCID'
        msgObj.messageType = 2
        msgObj.ICCID = msgObj.packet.simId
        msgObj.message = btoa('sim update')
        messageData.push(msgObj)
      }
      fireStore.collection('SIMmessages').add({
        messages: messageData,
        time: moment().format('YYYY-MM-DD HH:mm'),
        user: this.$store.getters.user.name
      }).then((val) => {
        this.startSnapshot(val.id)
        this.messageSent = true
      }).catch((error) => {
        alert('Unexpected Error Occured')
        console.log(error)
      })
    }
  }
}
</script>




// WEBPACK FOOTER //
// BulkSMS.vue?51379944